module.exports = __webpack_public_path__ + "static/media/DFPHannotateW5-B5-TW.ce52472b.svg";